import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExtendedBookmarkStar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M15 19.375L11.875 21.25L12.7083 17.7083L9.95833 15.3125L13.5833 15L15 11.6667L16.4167 15L20.0417 15.3125L17.2917 17.7083L18.125 21.25L15 19.375ZM7.5 26.875V8.125C7.5 7.4375 7.74479 6.84896 8.23438 6.35937C8.72396 5.86979 9.3125 5.625 10 5.625H20C20.6875 5.625 21.276 5.86979 21.7656 6.35937C22.2552 6.84896 22.5 7.4375 22.5 8.125V26.875L15 23.75L7.5 26.875Z",
		fill: "url(#paint0_linear_bookmark_star)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_bookmark_star",
		x1: 7.5,
		y1: 26.875,
		x2: 26.5,
		y2: 11,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", { stopColor: "#142F95" }),
			/* @__PURE__ */ _jsx("stop", {
				offset: .5,
				stopColor: "#2563EB"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#CACBFF"
			})
		]
	}) })]
});
export default SvgExtendedBookmarkStar;
